const APP_URL_API = process.env.REACT_APP_URL_API || 'https://donation.inisiatif.id/api/v2';

export {
  APP_URL_API
}